import core from "@/helpers/client";
const userService = {
  async headUserAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users?no-cache=1`,
      params
    );
    return result;
  },
  async getUsersAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users?no-cache=1`,
      params
    );
    return result;
  },
  async getUserAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users/${id}?no-cache=1`
    );
    return result;
  },
  async createUserAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users`,
      model
    );
    return result;
  },
  async updateUserAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users/${id}`,
      model
    );
    return result;
  },
  async deleteBrandMasterByIdAsync(id) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users/${id}`
    );
    return result;
  },
  async updateSyncAdUserAsync(id) {
    
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}api/v1/users/${id}/activedirectory/crc_id`
    );
    return result;
  },

};
export default userService;
